export const PREFLIGHT = 'player-events/PREFLIGHT';
export function preflight(player) {
  return {
    type: PREFLIGHT,
    player,
  };
}

export const VIEWABLE = 'player-events/VIEWABLE';
export function viewable(player) {
  return {
    type: VIEWABLE,
    player,
  };
}

export const PLAYING = 'player-events/PLAYING';
export function playing(player) {
  return {
    type: PLAYING,
    player,
  };
}

export const PAUSE = 'player-events/PAUSE';
export function pause(player) {
  return {
    type: PAUSE,
    player,
  };
}

export const STREAM_ENDED = 'player-events/STREAM_ENDED';
export function streamEnded(player) {
  return {
    type: STREAM_ENDED,
    player,
  };
}

export const DESTROY = 'player-events/DESTROY';
export function destroy(player) {
  return {
    type: DESTROY,
    player,
  };
}

export const FULLSCREEN = 'player-events/FULLSCREEN';
export function fullscreen(player) {
  return {
    type: FULLSCREEN,
    player,
  };
}

export const INITIALIZED = 'player-events/INITIALIZED';
export function initialized(player) {
  return {
    type: INITIALIZED,
    player,
  };
}

export const OFFSET_FROM_LIVE = 'player-events/OFFSET_FROM_LIVE';
export function offsetFromLive(player) {
  return {
    type: OFFSET_FROM_LIVE,
    player,
  };
}

export const TIMEUPDATE = 'player-events/TIMEUPDATE';
export function timeupdate(player) {
  return {
    type: TIMEUPDATE,
    player,
  };
}

export const CHROMECAST_TIMEUPDATE = 'player-events/CHROMECAST_TIMEUPDATE';
export function chromecastTimeupdate(player, event) {
  return {
    type: CHROMECAST_TIMEUPDATE,
    player,
    event,
  };
}

export const BUFFERING = 'player-events/BUFFERING';
export function buffering(player) {
  return {
    type: BUFFERING,
    player,
  };
}

export const VOLUMECHANGE = 'player-events/VOLUMECHANGE';
export function volumeChange(player) {
  return {
    type: VOLUMECHANGE,
    player,
  };
}

export const ADS_TIMEUPDATE = 'player-events/ADS_TIMEUPDATE';
export function adsTimeupdate(player, event) {
  return {
    type: ADS_TIMEUPDATE,
    player,
    event,
  };
}

export const CHROMECAST_AVAILABLE = 'player-events/CHROMECAST_AVAILABLE';
export function chromecastAvailable(player) {
  return {
    type: CHROMECAST_AVAILABLE,
    player,
  };
}

export const AIRPLAY_AVAILABLE = 'player-events/AIRPLAY_AVAILABLE';
export function airplayAvailable(player) {
  return {
    type: AIRPLAY_AVAILABLE,
    player,
  };
}

export const AIRPLAYING = 'player-events/AIRPLAYING';
export function airplaying(player) {
  return {
    type: AIRPLAYING,
    player,
  };
}

export const CHROMECAST_ACTIVATED = 'player-events/CHROMECAST_ACTIVATED';
export function chromecastActivated(player) {
  return {
    type: CHROMECAST_ACTIVATED,
    player,
  };
}

export const CHROMECAST_DEACTIVATED = 'player-events/CHROMECAST_DEACTIVATED';
export function chromecastDeactivated(player) {
  return {
    type: CHROMECAST_DEACTIVATED,
    player,
  };
}

export const ADS_ACTIVATED = 'player-events/ADS_ACTIVATED';
export function adsActivated(player) {
  return {
    type: ADS_ACTIVATED,
    player,
  };
}

export const ADS_PLAYING = 'player-events/ADS_PLAYING';
export function adsPlaying(player, event) {
  return {
    type: ADS_PLAYING,
    player,
    event,
  };
}

export const ADS_PAUSE = 'player-events/ADS_PAUSE';
export function adsPause(player) {
  return {
    type: ADS_PAUSE,
    player,
  };
}

export const ADS_ENDED = 'player-events/ADS_ENDED';
export function adsEnded(player) {
  return {
    type: ADS_ENDED,
    player,
  };
}

export const ADS_DEACTIVATED = 'player-events/ADS_DEACTIVATED';
export function adsDeactivated(player) {
  return {
    type: ADS_DEACTIVATED,
    player,
  };
}

export const DAI_ADS_PLAYING = 'player-events/DAI_ADS_PLAYING';
export const daiAdsPlaying = () => ({
  type: DAI_ADS_PLAYING,
});

export const DAI_ADS_ENDED = 'player-events/DAI_ADS_ENDED';
export const daiAdsEnded = () => ({
  type: DAI_ADS_ENDED,
});

export const ERROR = 'player-events/ERROR';
export function error(player) {
  return {
    type: ERROR,
    player,
  };
}

export const ENTITLEMENT = 'player-events/ENTITLEMENT';
export function entitlement(player) {
  return {
    type: ENTITLEMENT,
    player,
  };
}

export const PINCODE_INCORRECT = 'player-events/PINCODE_INCORRECT';
export function pincodeIncorrect(player) {
  return {
    type: PINCODE_INCORRECT,
    player,
  };
}

export const PINCODE_REQUIRED = 'player-events/PINCODE_REQUIRED';
export function pincodeRequired(player) {
  return {
    type: PINCODE_REQUIRED,
    player,
  };
}

export const SET_CURRENT_TIME = 'player-events/SET_CURRENT_TIME';
export function setCurrentTime(currentTime) {
  return {
    type: SET_CURRENT_TIME,
    detail: {
      currentTime,
    },
  };
}

export const CHANGEAUDIOTRACK = 'player-events/CHANGEAUDIOTRACK';
export function changeAudioTrack(audioTrack) {
  return {
    type: CHANGEAUDIOTRACK,
    audioTrack,
  };
}

export const CHANGETEXTTRACK = 'player-events/CHANGETEXTTRACK';
export function changeTextTrack(subtitleTrack) {
  return {
    type: CHANGETEXTTRACK,
    subtitleTrack,
  };
}

export const CHANGEBITRATE = 'player-events/CHANGEBITRATE';
export function changeBitrate(bitrate) {
  return {
    type: CHANGEBITRATE,
    bitrate,
  };
}
